import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DayPicker, { DateUtils } from 'react-day-picker/DayPicker';
import { removeTime } from "../../../../helpers/dateTime";
import './date_picker.scss';

export const DatePicker = ({
    disabled,
    enabledDays,
    initialDate,
    maxDate,
    minDate,
    onDayClick,
    onMonthChange,
    selectedDays,
    variant = 'inline',
    yearsBackward,
    yearsForward
}) => {
    const currentYear = new Date().getFullYear();

    if (disabled) {
        minDate = new Date();
        maxDate = new Date();
    } else {
        if (!minDate && yearsBackward) {
            minDate = new Date(currentYear - yearsBackward, 0);
        }

        if (!maxDate && yearsForward) {
            maxDate = new Date(currentYear + yearsForward, 11);
        }
    }

    minDate = removeTime(minDate);
    maxDate = removeTime(maxDate);

    const handleDayClick = (day, { selected, disabled }) => {
        if (onDayClick) {
            onDayClick(day, { selected, disabled });
        }
    }

    const handleYearMonthChange = (month) => {
        if (onMonthChange) {
            onMonthChange(month);
        }
    }

    const isDayDisabled = (day, enabledDays, disabled) => {
        if (disabled === true) {
            return true;
        }
        else {
            if (enabledDays && enabledDays.length > 0) {
                var disableDay = enabledDays.some(disabledDay =>
                    DateUtils.isSameDay(day, disabledDay)
                );
                return (!disableDay);
            }
        }
    }

   return (
        <div className='bsw-day-picker'>
            {variant === 'input'
                ? <div>To Be Created</div>
               : <DayPicker
                   selectedDays={selectedDays}
                   onDayClick={handleDayClick}
                   onMonthChange={(month) => handleYearMonthChange(month)}
                   disabledDays={day => isDayDisabled(day, enabledDays, disabled)}
                   month={initialDate || minDate}
                   fromMonth={minDate}
                   toMonth={maxDate}
                   showOutsideDays={false}
                    />
            }
        </div>
    )
}

DatePicker.propTypes = {
    disabled: PropTypes.any,
    enabledDays: PropTypes.array,
    initialDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    minDate: PropTypes.instanceOf(Date),
    onDayClick: PropTypes.func,
    onMonthChange: PropTypes.func,
    selectedDays: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.instanceOf(Date),
        PropTypes.object,
    ]),
    variant: PropTypes.oneOf(['inline', 'input']),
    yearsBackward: PropTypes.number,
    yearsForward: PropTypes.number
};